import { consts } from '../actions/segmentAttractivenessActions';

const initialState = {
  
  fetched: false,
  fetching: false,
  error: null,
  //get Custemer
  getCustomerGroupsFetching: false,
  getCustomerGroupsData: {},
  // get attractivness
  attractivnessFetching: false,
  attractivnessData: {},
  //craet Criteria
  craetCriteriaFetching: false,
  craetCriteriaData: {},
  // get segments
  getSegmentFetching: false,
  getSegmentData: {},


};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    
    case consts.GET_CUSTOMER_GROUP_PENDING: {
      state = Object.assign({}, state, { getCustomerGroupsFetching: true});
      break;
    }
    case consts.GET_CUSTOMER_GROUP_FULFILLED: {
        state = Object.assign({}, state, { getCustomerGroupsFetching: false, getCustomerGroupsData: action.data });
        break;
    }
    case consts.GET_CUSTOMER_GROUP_REJECT: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }

    case consts.GET_SEGMENT_PENDING: {
      state = Object.assign({}, state, { getSegmentFetching: true});
      break;
    }
    case consts.GET_SEGMENT_FULFILLED: {
        state = Object.assign({}, state, { getSegmentFetching: false, getSegmentData: action.data });
        break;
    }
    case consts.GET_SEGMENT_REJECT: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }

    case consts.GET_ATTRACTIVNESS_PENDING: {
      state = Object.assign({}, state, { attractivnessFetching: true});
      break;
    }
    case consts.GET_ATTRACTIVNESS_FULFILLED: {
        state = Object.assign({}, state, { attractivnessFetching: false, attractivnessData: action.data });
        break;
    }
    case consts.GET_ATTRACTIVNESS_REJECTED: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }

    case consts.CREATE_CRITERIA_TAB_PENDING: {
      state = Object.assign({}, state, { craetCriteriaFetching: true});
      break;
    }
    case consts.CREATE_CRITERIA_TAB_FULFILLED: {
        state = Object.assign({}, state, { craetCriteriaFetching: false, craetCriteriaData: action.data });
        break;
    }
    case consts.CREATE_CRITERIA_TAB_REJECTED: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }
    
  }
  return state;
}





// WEBPACK FOOTER //
// ./src/store/reducers/segmentAttractivenessReducer.js